import {
  fork,
  put,
  all,
  call,
  takeLatest,
} from "redux-saga/effects";

import {
  getCspmChecksSuccessful,
  getCspmChecksFailure,
  getCspmResourcesSuccessful,
  getCspmResourcesFailure,
  createCspmWorkloadSuccessful,
  createCspmWorkloadFailure,
  editCspmWorkloadSuccessful,
  editCspmWorkloadFailure,
  deleteCspmWorkloadSuccessful,
  deleteCspmWorkloadFailure,
  initiateCspmScanSuccessful,
  initiateCspmScanFailure,
  downloadCspmReportSuccessful,
  downloadCspmReportFailure,
} from "./cspmSlice";

import {
  getCspmChecks as getCspmChecksApi,
  getCspmResources as getCspmResourcesApi,
  createComplianceWorkload as createComplianceWorkloadApi,
  editComplianceWorkload as editComplianceWorkloadApi,
  deleteComplianceWorkload as deleteComplianceWorkloadApi,
  initiateComplianceScan as initiateComplianceScanApi,
  downloadCspmReport as downloadCspmReportApi,
} from "../../helpers/auth_aws_helper";

function* getCspmChecks({ payload }) {
  try {
    console.log("about to call *getCspmChecks() with payload:", payload);
    const response = yield call(getCspmChecksApi, payload);
    console.log("*getCspmChecksApi() response: ", response);

    if (response && response.status === 200) {
      yield put(getCspmChecksSuccessful(response));
    } else {
      let message = "An error occurred while fetching CSPM checks";
      if (response.message) {
        message = response.message;
      } else if (response.data) {
        message = typeof response.data === 'string' ? response.data : response.data.message || response.data.error || JSON.stringify(response.data);
      }
      yield put(getCspmChecksFailure({ message }));
    }
  } catch (error) {
    console.error("Error in getCspmChecks saga:", error);
    let message = "An error occurred while fetching CSPM checks";
    
    if (error.message) {
      message = error.message;
    } else if (error.response?.data) {
      message = typeof error.response.data === 'string' 
        ? error.response.data 
        : error.response.data.message || error.response.data.error || JSON.stringify(error.response.data);
    }
    
    yield put(getCspmChecksFailure({ message }));
  }
}

function* getCspmResources({ payload }) {
  try {
    console.log("about to call *getCspmResources() with payload:", payload);
    const response = yield call(getCspmResourcesApi, payload);
    console.log("*getCspmResourcesApi() response: ", response);

    if (response && response.status === 200) {
      yield put(getCspmResourcesSuccessful(response));
    } else {
      let message = "An error occurred while fetching CSPM resources";
      if (response.message) {
        message = response.message;
      } else if (response.data) {
        message = typeof response.data === 'string' ? response.data : response.data.message || response.data.error || JSON.stringify(response.data);
      }
      yield put(getCspmResourcesFailure({ message }));
    }
  } catch (error) {
    console.error("Error in getCspmResources saga:", error);
    let message = "An error occurred while fetching CSPM resources";
    
    if (error.message) {
      message = error.message;
    } else if (error.response?.data) {
      message = typeof error.response.data === 'string' 
        ? error.response.data 
        : error.response.data.message || error.response.data.error || JSON.stringify(error.response.data);
    }
    
    yield put(getCspmResourcesFailure({ message }));
  }
}

function* createCspmWorkload({ payload }) {
  try {
    const response = yield call(createComplianceWorkloadApi, payload);
    if (response && response.status === 200) {
      yield put(createCspmWorkloadSuccessful(response));
    } else {
      let message = "An error occurred while creating CSPM workload";
      if (response.message) {
        message = response.message;
      } else if (response.data) {
        message = typeof response.data === 'string' ? response.data : response.data.message || response.data.error || JSON.stringify(response.data);
      }
      yield put(createCspmWorkloadFailure({ message }));
    }
  } catch (error) {
    let message = "An error occurred while creating CSPM workload";
    if (error.message) {
      message = error.message;
    } else if (error.response?.data) {
      message = typeof error.response.data === 'string' ? error.response.data : error.response.data.message || error.response.data.error || JSON.stringify(error.response.data);
    }
    yield put(createCspmWorkloadFailure({ message }));
  }
}

function* editCspmWorkload({ payload }) {
  try {
    const response = yield call(editComplianceWorkloadApi, payload);
    if (response && response.status === 200) {
      yield put(editCspmWorkloadSuccessful(response));
    } else {
      let message = "An error occurred while editing CSPM workload";
      if (response.message) {
        message = response.message;
      } else if (response.data) {
        message = typeof response.data === 'string' ? response.data : response.data.message || response.data.error || JSON.stringify(response.data);
      }
      yield put(editCspmWorkloadFailure({ message }));
    }
  } catch (error) {
    let message = "An error occurred while editing CSPM workload";
    if (error.message) {
      message = error.message;
    } else if (error.response?.data) {
      message = typeof error.response.data === 'string' ? error.response.data : error.response.data.message || error.response.data.error || JSON.stringify(error.response.data);
    }
    yield put(editCspmWorkloadFailure({ message }));
  }
}

function* deleteCspmWorkload({ payload }) {
  try {
    const response = yield call(deleteComplianceWorkloadApi, payload);
    if (response && response.status === 200) {
      yield put(deleteCspmWorkloadSuccessful(response));
    } else {
      let message = "An error occurred while deleting CSPM workload";
      if (response.message) {
        message = response.message;
      } else if (response.data) {
        message = typeof response.data === 'string' ? response.data : response.data.message || response.data.error || JSON.stringify(response.data);
      }
      yield put(deleteCspmWorkloadFailure({ message }));
    }
  } catch (error) {
    let message = "An error occurred while deleting CSPM workload";
    if (error.message) {
      message = error.message;
    } else if (error.response?.data) {
      message = typeof error.response.data === 'string' ? error.response.data : error.response.data.message || error.response.data.error || JSON.stringify(error.response.data);
    }
    yield put(deleteCspmWorkloadFailure({ message }));
  }
}

function* initiateCspmScan({ payload }) {
  try {
    const response = yield call(initiateComplianceScanApi, payload);
    if (response && response.status === 200) {
      yield put(initiateCspmScanSuccessful(response));
    } else {
      let message = "An error occurred while initiating CSPM scan";
      if (response.message) {
        message = response.message;
      } else if (response.data) {
        message = typeof response.data === 'string' ? response.data : response.data.message || response.data.error || JSON.stringify(response.data);
      }
      yield put(initiateCspmScanFailure({ message }));
    }
  } catch (error) {
    let message = "An error occurred while initiating CSPM scan";
    if (error.message) {
      message = error.message;
    } else if (error.response?.data) {
      message = typeof error.response.data === 'string' ? error.response.data : error.response.data.message || error.response.data.error || JSON.stringify(error.response.data);
    }
    yield put(initiateCspmScanFailure({ message }));
  }
}

function* downloadCspmReport({ payload }) {
  try {
    const response = yield call(downloadCspmReportApi, payload);
    console.log("🚀 ~ function*downloadCspmReport ~ response:", response)
    if (response && response.status === 200) {
      delete response.status;
      console.log("🚀 ~ function*downloadComplianceReportSaga ~ response:", Object.values(response).join(''))
      yield put(downloadCspmReportSuccessful((Object.values(response).join(''))));
    } else {
      let message = "An error occurred while downloading CSPM report";
      if (response.message) {
        message = response.message;
      } else if (response.data) {
        message = typeof response.data === 'string' ? response.data : response.data.message || response.data.error || JSON.stringify(response.data);
      }
      yield put(downloadCspmReportFailure({ message }));
    }
  } catch (error) {
    let message = "An error occurred while downloading CSPM report";
    if (error.message) {
      message = error.message;
    } else if (error.response?.data) {
      message = typeof error.response.data === 'string' ? error.response.data : error.response.data.message || error.response.data.error || JSON.stringify(error.response.data);
    }
    yield put(downloadCspmReportFailure({ message }));
  }
}

export function* watchCspm() {
  yield takeLatest("cspm/getCspmChecks", getCspmChecks);
  yield takeLatest("cspm/getCspmResources", getCspmResources);
  yield takeLatest("cspm/createCspmWorkload", createCspmWorkload);
  yield takeLatest("cspm/editCspmWorkload", editCspmWorkload);
  yield takeLatest("cspm/deleteCspmWorkload", deleteCspmWorkload);
  yield takeLatest("cspm/initiateCspmScan", initiateCspmScan);
  yield takeLatest("cspm/downloadCspmReport", downloadCspmReport);
}

export function* cspmSaga() {
  yield all([fork(watchCspm)]);
}

export default cspmSaga; 